<template>
  <div id="app">
    <Suspense>
      <router-view />
    </Suspense>
    <div id="message-box"></div>

    <div id="mloading" class="loading">
      <!-- <div class="loadingio-spinner-dual-ball-p4fazz803e">
        <div class="ldio-z76ep1av69">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div> -->
      <div class="loading-cover"></div>
      <div class="loading-svg">
        <div class="effect-1 effects"></div>
      </div>
    </div>
    <modals-container></modals-container>
    <dialog-wrapper />
  </div>
</template>

<script>
import {DialogWrapper} from 'vue3-promise-dialog';
import {useContextStore} from '@/stores/context';
import {useWebsocketStore} from '@/stores/websocketStore';
import {onMounted} from 'vue';
import useTheme from '@/composables/utilities/useTheme';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
export default {
  components: {
    DialogWrapper,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    const me = this;
  },
  mounted() {
    const me = this;
    me.initEnterSameTab();
  },
  setup() {
    const contextStore = useContextStore();
    const socketStore = useWebsocketStore();

    onMounted(() => {
      if (!contextStore.hasExpiredToken()) {
        socketStore.connectSocket();
      }
      const {initTheme} = useTheme();
      initTheme();

      // trường hợp license hết hạn
      if (commonFn.checkRouterExpiredDate()) {
        return;
      }
      // trường hợp license sắp hết hạn
      if (contextStore.Context?.ShowWarningDate) {
        popupUtil.show('ExpireWarning');
      }
    });

    return {};
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;

      window.addEventListener('keydown', function (e) {
        if (e.which === 13 && !e.shiftKey) {
          const tag = e.target.tagName.toLowerCase();
          if (['button', 'a'].indexOf(tag) > -1) {
            return;
          }

          if ('textarea' == tag && e.shiftKey) {
            return;
          }
          // Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          // Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (e.target.closest('.ms-grid-viewer') && e.target.closest('tbody')) {
            return;
          }
          // ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest('.remain-focus-when-enter')) {
            return;
          }
          const focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>
